<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            <el-breadcrumb-item>日志统计</el-breadcrumb-item>
        </el-breadcrumb>

        <el-card class="box-card">
            <el-form :inline="true" :model="logsForm" class="demo-form-inline">
              <el-form-item label="">
                <el-select v-model="logsForm.menuName" placeholder="请选择" >
                  <el-option-group
                    v-for="group in options"
                    :key="group.label"
                    :label="group.label">
                    <el-option
                      v-for="item in group.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-date-picker v-model="logsForm.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-date-picker v-model="logsForm.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="clicksearch">查询</el-button>
                <el-button type="success" @click="clickexcel()">导出</el-button>
              </el-form-item>
            </el-form>
            <!-- 列表 -->
           <el-table v-loading="loading" :data="dataList" border stripe>
                <el-table-column prop="Adminname" label="操作员"></el-table-column>
                <el-table-column prop="Num" label="数量"></el-table-column>
           </el-table>
           <el-card class="box-card">
             <ve-histogram :data="trainingData" :extend="trainingExtend" :legend-visible="false" :colors="trainingColors"></ve-histogram>
           </el-card>
        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyLogsTongJi',
  data () {
    // 训练数据反馈表
    this.trainingExtend = {
      series (v) {
        v.forEach(i => {
          i.barWidth = 20
        })
        return v
      }
    }
    return {
      loading: false,
      logsForm: {
        menuName: '更新设备',
        begintime: '',
        endtime: ''
      },
      dataList: [],
      trainingColors: ['#4ad2ff'],
      trainingData: {
        columns: ['Adminname', 'Num'],
        rows: []
      },
      options: [{
        label: '睿云WEB-常规设备操作',
        options: [{
          value: '增加设备',
          label: '增加设备'
        }, {
          value: '更新设备',
          label: '更新设备'
        }, {
          value: '更改设备归属机构',
          label: '更改设备归属机构'
        }, {
          value: '批量更改设备归属机构',
          label: '批量更改设备归属机构'
        }, {
          value: '添加设备暂停记录',
          label: '添加设备暂停记录'
        }]
      }, {
        label: '睿云WEB-特殊设备操作',
        options: [{
          value: '清空设备数据',
          label: '清空设备数据'
        }, {
          value: '批量处理导入设备',
          label: '批量处理导入设备'
        }, {
          value: '批量处理清空设备',
          label: '批量处理清空设备'
        }, {
          value: '一键解绑设备所有用户',
          label: '一键解绑设备所有用户'
        }]
      }, {
        label: '睿云WEB-涉及设备操作',
        options: [{
          value: '系统设置(强制删除机构)',
          label: '系统设置(强制删除机构)'
        }, {
          value: '系统设置(更新机构)',
          label: '系统设置(更新机构)'
        }]
      }, {
        label: '睿云WEB-常规用户操作',
        options: [{
          value: '增加客户分钟_天数',
          label: '延期'
        }]
      },{
        label: '睿云APP-常规设备操作',
        options: [{
          value: 'PostBomsnSaletype',
          label: '修改设备类型'
        }, {
          value: 'Postdevicejigou',
          label: '修改设备归属机构'
        }, {
          value: 'Postuseropenorstop',
          label: '开启/暂停'
        }, {
          value: 'Postdelay',
          label: '延期'
        }, {
          value: 'Postbind',
          label: '绑定'
        }, {
          value: 'Postunbind',
          label: '解绑'
        }, {
          value: 'Postuserjigou',
          label: '修改用户归属机构【会同步修改设备归属机构】'
        }, {
          value: 'Postnewuser',
          label: '注册用户'
        }]
      }, ],
    }
  },
  mounted () {
    this.logsForm.begintime = Vue.prototype.getFirstDay()
    this.logsForm.endtime = Vue.prototype.getLastDay()
    this.apiGetlogTongJi()
  },
  methods: {
    clicksearch () {
      this.apiGetlogTongJi()
    },
    clickexcel () {
      this.apiExcelLogsTongJi()
    },
    apiGetlogTongJi: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        kwdmenuname: that.logsForm.menuName,
        begintime: that.logsForm.begintime,
        endtime: that.logsForm.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetlogTongJi, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
            that.trainingData.rows = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiExcelLogsTongJi: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        kwdmenuname: that.logsForm.menuName,
        begintime: that.logsForm.begintime,
        endtime: that.logsForm.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelLogsTongJi, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
